import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="previous-messages"
export default class extends Controller {
  static targets = [ "container" ]

  connect() {
    this.containerTarget.addEventListener(
      "scroll",
      this.loadPreviousMessages
    )

    document.addEventListener(
      "turbo:before-stream-render",
      this.beforeStreamRender
    )
  }

  disconnect() {
    this.containerTarget.removeEventListener(
      "scroll",
      this.loadPreviousMessages
    )

    document.removeEventListener(
      "turbo:before-stream-render",
      this.beforeStreamRender
    )
  }

  loadPreviousMessages = () => {
    if (this.containerTarget.scrollTop > 100) return

    const frame = this.element.querySelector("#previous_messages")

    if (!frame || frame.src) return

    frame.src = frame.dataset.previousMessagesSrcValue
  }

  beforeStreamRender = (event) => {
    if (event.target.action !== "prepend") return
    if (event.target.target !== "messages") return

    this.preserveScroll()

    const render = event.detail.render

    event.detail.render = () => {
      render(event.target)

      requestAnimationFrame(() => {
        this.restoreScroll()
      })
    }
  }

  preserveScroll() {
    this.previousScrollHeight = this.containerTarget.scrollHeight
    this.previousScrollTop = this.containerTarget.scrollTop
  }

  restoreScroll() {
    const heightDifference =
      this.containerTarget.scrollHeight - this.previousScrollHeight

    this.containerTarget.scrollTop =
      this.previousScrollTop + heightDifference
  }
}
